const initialState = {
  isAuthenticated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_USER_AUTH":
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    default:
      return state;
  }
}
